import { SystemRandomGenerator, RandomGenerator } from './RandomGenerator';
export class RangedValue {

    private _min: number;

    private _max: number;

    static fromString(str: string): RangedValue {
        if (str) {
            var arr: Array<string> = str.split(",");
            if (arr.length) {
                var value0: number = parseFloat(arr[0]);
                if (arr.length == 1) {
                    return new RangedValue(value0, value0);
                }

                var value1: number = parseFloat(arr[1]);
                return new RangedValue(value0, value1);
            }
        }

        return new RangedValue(0, 0);
    }

    constructor(min: number, max: number) {
        this._min = Math.min(min, max);
        this._max = Math.max(min, max);
    }

    public get min(): number {
        return this._min;
    }

    public get max(): number {
        return this._max;
    }

    public get range(): number {
        return this._max - this._min;
    }

    public calcValueInRange(percent: number): number {
        if (percent <= 0)
            return this._min;

        if (percent >= 1)
            return this._max;

        return this._min + percent * this.range;
    }

    public calcPercentOfValue(value:number):number
    {
        if (value <= this._min)
            return 0;
        if (value >= this._max)
            return 1;
        return (value - this._min) / this.range;
    }

    public getRandomInRange(rng:RandomGenerator = null):number
    {
        if (rng == null)
            rng = new SystemRandomGenerator();

        return rng.nextBetween(this._min, this._max);
    }

    public isValueInRange(value:number):boolean
    {
        return value >= this._min && value <= this._max;
    }

    public restrictValue(value:number):number {
        return Math.max(this._min, Math.min(this._max, value));
    }
}


// WEBPACK FOOTER //
// ./src/framework/utils/RangedValue.ts